/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.o-summary__content {
  overflow-y: hidden;
  padding: 2px;
  left: -2px;
  top: -2px;
  position: relative;
}
.o-summary__btn {
  position: relative;
  z-index: 2;
  display: block;
  width: 100%;
  padding-top: 15px;
  padding-bottom: 15px;
  border: dotted var(--pacific);
  border-width: 1px 0;
  text-align: center;
  color: var(--pacific);
  background: #fff;
}
.o-summary__btn:focus {
  outline: 1px dotted var(--pacific);
  outline-offset: 1px;
}
.o-summary__btn[aria-expanded=false]::before {
  display: block;
  pointer-events: none;
  height: 2.75em;
  margin: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: calc(-100% + 2px);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
  content: "";
}
@media print {
  .o-summary__btn[aria-expanded=false]::before {
    background: none;
  }
}
.o-summary__btn[aria-expanded=false]::before .print {
  background: none;
}
.no-js .o-summary__btn {
  display: none;
}
@media only screen and (min-width: 601px) {
  .o-summary--mobile .o-summary__btn {
    display: none;
  }
}